<template>
  <div v-show="isShow">
    <div><img @click="returnPage()" class="return-btn" src="../../assets/return-page.png" height="36" width="20"/></div>
    <div class="pro-head">
      {{type==1?'论文查重':type==2?'格式检测':type==3?'毕设（论文）管理系统':type==4?'论文抽检':''}}
    </div>
    <div v-if="type==1">
      <div>
        <img style="width: 100%" src="../../assets/cpDetails/cpdetail1.png" alt="">
        <div class="con-cp">
          <div style="display: flex">
            <div class="con-title">独特算法</div>
            <div class="con-title">神经语言级侦测技术</div>
            <div class="con-title">千亿文献资源库</div>
          </div>
          <div style="display: flex">
            <div class="con-title">自建资源库</div>
            <div class="con-title">准确率99%以上</div>
            <div class="con-title">查重检测报告</div>
          </div>
          <div style="display: flex">
            <div class="con-title">查重批注</div>
            <div class="con-title">急速检测%以上</div>
          </div>
        </div>
      </div>
      <div class="headImgSty" style="margin: 15px">
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails1-1.png" alt="">
      </div>
      <div class="headImgSty footImgSty">
        <img style="width: 100%;height: 100%" src="../../assets/cpDetails/cpdetails1-2.png" alt="">
      </div>
    </div>
    <div v-if="type==2">
      <div>
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails2.png" alt="">
        <div class="con-cp">
          <div style="display: flex">
            <div class="con-title">国标格式要求</div>
            <div class="con-title">高校定制格式要求</div>
            <div class="con-title">检测主体完整性</div>
          </div>
          <div style="display: flex">
            <div class="con-title">匹配GB、APA、MLA等国际格式规范</div>
            <div class="con-title">格式检测报告</div>
          </div>
          <div style="display: flex">
            <div class="con-title">在线预览</div>
            <div class="con-title">格式批注</div>
          </div>
        </div>
      </div>
      <div class="headImgSty">
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails2-1.png" alt="">
      </div>
      <div class="headImgSty footImgSty">
        <img style="width: 100%;" src="../../assets/cpDetails/cpdetails2-2.png" alt="">
      </div>
    </div>
    <div v-if="type==3">
      <div>
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails3.png" alt="">
        <div class="con-cp">
          <div style="display: flex">
            <div class="con-title">选题管理</div>
            <div class="con-title">过程文档管理</div>
            <div class="con-title">论文检测</div>
            <div class="con-title">论文管理</div>
            <div class="con-title">答辩管理</div>
          </div>
          <div style="display: flex">
            <div class="con-title">盲评与推优</div>
            <div class="con-title">成绩与归档</div>
            <div class="con-title">异常数据管理 </div>
            <div class="con-title">统计报表</div>
          </div>
          <div style="display: flex">
            <div class="con-title">通知公告管理</div>
            <div class="con-title">资料库</div>
            <div class="con-title">系统管理</div>
            <div class="con-title">参数配置</div>
          </div>
        </div>
      </div>
      <div class="headImgSty">
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails3-1.png" alt="">
      </div>
      <div class="headImgSty">
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails3-2.png" alt="">
      </div>
      <div class="headImgSty">
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails3-3.png" alt="">
      </div>
      <div class="headImgSty footImgSty">
        <img style="width: 100%;" src="../../assets/cpDetails/cpdetails3-4.png" alt="">
      </div>
    </div>
    <div v-if="type==4">
      <div>
        <img style="width: 100%" src="../../assets/cpDetails/cpdetails4.png" alt="">
        <div class="con-cp con-cp4">
          <div style="display: flex">
            <div class="con-title">首创AI评阅</div>
            <div class="con-title">遵照教育部学位中心抽检</div>
          </div>
          <div style="display: flex">
            <div class="con-title">拥有30万评审专家</div>
          </div>
        </div>
      </div>
      <div class="headImgSty">
        <img style="width: 90%" src="../../assets/cpDetails/cpdetails4-2.png" alt="">
      </div>
      <div class="headImgSty footImgSty">
        <img style="width: 90%" src="../../assets/cpDetails/cpdetails4-3.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productDetails",
  data(){
    return{
      type:'',
      isShow:false,
    }
  },
  mounted() {

  },
  methods:{
    init(type){
      this.isShow = true
      this.type = type
    },
    returnPage(){
      this.isShow = false
      this.$emit('returnPage')
    },
  }
}
</script>

<style scoped>
.con-title{
    background: #F1F6FE;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 400;
    color: #2664E2;
    line-height: 24px;
    padding: 0 4px 0 4px;
    margin: 3px;
    margin-top: 5px;
    margin-left: 6px;
}
.con-cp{
    width: 95%;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
    border-radius: 15px;
    position: relative;
    margin: auto;
    left: 0;
    right: 0;
    top: -20px;
}
.con-cp4{
    height: 70px;
}
.pro-head{
    position: fixed;
    height: 64px;
    background: #005CE5;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    color: #FFFFFF;
    font-size: 18px;
    line-height: 65px;
    z-index: 9999;
}
.return-btn{
    position: fixed;
    z-index: 99999;
    margin: auto;
    top: 22px;
    left: 12px;
    width: 10px;
    height: 18px;
}
.headImgSty{
    padding-top: 10px;
}
.footImgSty{
    padding-bottom: 50px
}
</style>